module.exports = __webpack_public_path__ + "static/media/CC3-4.1d06ea0f.jpg";